export const NPS_STATUS_VALUES = ['open', 'assigned', 'resolved', 'closed'];

export const NPS_STATUS_OPTIONS = [
  { value: 'open', label: 'New' },
  { value: 'assigned', label: 'Assigned' },
  { value: 'resolved', label: 'Resolved' },
  { value: 'closed', label: 'Closed' },
];

export function getNpsStatusLabel(status) {
  const option = NPS_STATUS_OPTIONS.find((entry) => entry.value === status);
  return option?.label ?? status;
}

export const DEFAULT_NPS_STATUS_FILTER = ['open'];

export const NPS_ASSIGN_TEAMS = ['IT', 'Operations', 'Sales', 'Product', 'Finance', 'Marketing'];

export function parseNpsAssignedTeams(assignedTo) {
  if (assignedTo == null) return [];
  if (Array.isArray(assignedTo)) {
    return assignedTo
      .map((entry) => String(entry).trim())
      .filter((team) => NPS_ASSIGN_TEAMS.includes(team));
  }

  const str = String(assignedTo).trim();
  if (!str) return [];

  return str
    .split(',')
    .map((entry) => entry.trim())
    .filter((team) => NPS_ASSIGN_TEAMS.includes(team));
}

export function formatNpsAssignedTo(teams) {
  const unique = [...new Set((teams || []).filter((team) => NPS_ASSIGN_TEAMS.includes(team)))];
  if (unique.length === 0) return '';
  return unique.join(', ');
}

export function npsAssignedTeamsEqual(a, b) {
  const left = [...(a || [])].sort().join('\0');
  const right = [...(b || [])].sort().join('\0');
  return left === right;
}

export function getNpsItemStatus(item) {
  const status = item?.status;
  if (NPS_STATUS_VALUES.includes(status)) return status;
  return 'open';
}

export function itemMatchesNpsStatusFilter(item, statuses) {
  if (!statuses || statuses.length === 0) return true;
  return statuses.includes(getNpsItemStatus(item));
}

export function isDefaultNpsStatusFilter(statuses) {
  return statuses?.length === 1 && statuses[0] === 'open';
}

export function showNpsResolutionUi(item) {
  const status = getNpsItemStatus(item);
  return status === 'resolved' || status === 'closed';
}

export function canNpsQueueActions(item) {
  const status = getNpsItemStatus(item);
  return status === 'open' || status === 'assigned';
}

/** Assign teams while case is not closed */
export function canNpsAssign(item) {
  const status = getNpsItemStatus(item);
  return status === 'open' || status === 'assigned' || status === 'resolved';
}

/**
 * Assign-only PUT must not change resolved → assigned (or other status).
 * Open/assigned transitions are owned by the API when teams are set or cleared.
 */
export function normalizeNpsAfterAssign(previousItem, updated) {
  if (!updated || !previousItem) return updated;
  if (getNpsItemStatus(previousItem) !== 'resolved') return updated;
  if (getNpsItemStatus(updated) === 'resolved') return updated;
  return { ...updated, status: 'resolved' };
}

export function canNpsReopen(item) {
  return getNpsItemStatus(item) === 'resolved';
}

/** Leadership sign-off: resolved → closed */
export function canNpsLeadershipClose(item) {
  return getNpsItemStatus(item) === 'resolved';
}
